import { render, staticRenderFns } from "./stockDaysChart.vue?vue&type=template&id=60411bab"
import script from "./stockDaysChart.vue?vue&type=script&lang=js"
export * from "./stockDaysChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports